import { Flex, useScreenSize } from '@banhala/ui-kit';
import { Suspense } from 'react';
import { ActivityIndicator, ScrollView } from 'react-native';
import { useLogViewMyPersonalizationSize } from '../../hooks/useLogViewMyPersonalizationSize';
import { useMyPersonalizationSizeHydration } from '../../state';
import { useMyPageRoute } from '../../../../hooks/useMyPageRoute';
import { MeasureSpotsImage } from './MeasureSpotsImage';
import { MySizeSection } from './MySizeSection';
import { ProductCategoryTabBar } from './ProductCategoryTabBar';
import { SizeContentFooter } from './SizeContentFooter';
import { StandardCategoryTabBar } from './StandardCategoryTabBar';
import { useProductCategoryInitialValues } from '../../queries/useProductCategoryInitialValues';

const MyPersonalizationSizeContent = ({
  onClose: _onClose,
}: {
  onClose: () => void;
}) => {
  const { width: contentWidth } = useScreenSize();
  const { params } = useMyPageRoute<'MyPersonalization'>();
  const { data } = useProductCategoryInitialValues(params?.productCategorySno);
  useMyPersonalizationSizeHydration(data);
  useLogViewMyPersonalizationSize();

  return (
    <>
      <ScrollView
        contentContainerStyle={{
          width: contentWidth,
          paddingBottom: 40,
        }}
        showsVerticalScrollIndicator={false}
        style={{ flex: 1 }}
      >
        <StandardCategoryTabBar />
        <ProductCategoryTabBar />

        <Flex padding={{ top: 16 }} gap={16}>
          <MeasureSpotsImage />
          <Suspense
            fallback={
              <Flex.Center flex={1}>
                <ActivityIndicator />
              </Flex.Center>
            }
          >
            <MySizeSection />
          </Suspense>
        </Flex>
      </ScrollView>
      <SizeContentFooter />
    </>
  );
};

export default MyPersonalizationSizeContent;
